import { createContext, useContext } from 'react';
import { SnackbarActions } from './actions';
import { SnackbarState } from './reducer';

export const SnackbarContext = createContext({
  snackbarState: {} as SnackbarState,
  snackbarDispatch: (action: SnackbarActions) => {},
});

SnackbarContext.displayName = `SnackbarContext`;

export const useSnackbarContext = () => useContext(SnackbarContext);
